import { jsx as e, jsxs as a } from "@emotion/react/jsx-runtime";
import { Icon as n, Text as t, capitalize as o } from "@partoohub/ui";
import { AlertCardContainer as i, AlertCardTriggered as d, AlertCardIconTriggered as l, AlertCardDescriptionTriggered as c, StyledButton as s } from "./AlertCard.styled.js";
import { platformsButtonText as p } from "../../helpers.js";
const f = ({
  item: r
}) => /* @__PURE__ */ e(i, { children: /* @__PURE__ */ a(d, { direction: "row", alignItems: "top", children: [
  /* @__PURE__ */ e(l, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ e(n, { icon: r.icon, color: "danger" }) }),
  /* @__PURE__ */ a(c, { gap: "4px", children: [
    /* @__PURE__ */ e(t, { variant: "bodyMRegular", as: "span", children: r.message }),
    /* @__PURE__ */ a(t, { variant: "bodyMRegular", as: "span", color: "secondary", children: [
      r.date,
      " - ",
      o(r.product)
    ] }),
    /* @__PURE__ */ e(s, { dataTrackId: "action__alert", variant: "danger", appearance: "outlined", shape: "cube", size: "small", children: p[r.platform] })
  ] })
] }) });
export {
  f as AlertCard
};
